import { AuthErrorScreen } from '@/features/common/components/AuthErrorScreen';
import { LoadingScreen } from '@/features/common/components/LoadingScreen';
import { useAuth } from '@/hooks/useAuth';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

const ProtectedRoute = withAuthenticationRequired(
  () => {
    /**
     * If authorized, return an outlet that will render needed view
     * If not, return element that will navigate to Login page probably
     */
    const { isLoading, error } = useAuth();

    if (isLoading) {
      return <LoadingScreen />;
    }

    if (error) {
      return (
        <AuthErrorScreen
          error={
            error.status === 401 ? 'access_denied' : (error.code as string)
          }
        />
      );
    }

    return <Outlet />;
  },
  {
    onRedirecting: () => (
      <LoadingScreen text={'Redirecting you to the login page...'} />
    )
  }
);

export default ProtectedRoute;
